import supplierRecallService from '../../../services/supplier/supplier-recall'
import providerRecallService from '../../../services/provider/recall'
import { ENUM_PRODUCT_FIELD_DATA_TYPE,ENUM_DATE_TYPE_DEFAULT_VALUE } from '../../../misc/commons'
import ProductManager from '../ProductManager'
import ProviderProductTierView from '../provider-product-tier-view/index.vue'
import communicationProductService, { normalizeProductsFromApi, toUpsertPayload } from '../../../services/provider/communicationProduct'
import VueTagsInput from '@johmun/vue-tags-input'
import { is } from 'core-js/core/object'

export default {
    name: 'RecallResponseModal',
    components: {
        ProductManager,
        ProviderProductTierView,
        VueTagsInput
    },
    props: {
        CcEmails: {type: Object, default: []},
        recallData: {
            type: Object,
            default: () => ({})
        },
        communicationType: {
            type: String,
            default: 'RECALL'
        },
        providerCommunicationId: {
            type: String,
        },
        firstCompletedDatetime: {
            type: String,
            default: null
        },
        responseFormData: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            form: {
                recallName: '',
                recallDate: '',
                recallingFirmEmail: '',
                contactInfo: {
                    yourName: '',
                    yourTitle: '',
                    emailAddress: '',
                    telephoneNumber: ''
                },
                facilityInfo: [{
                    providerName: '',
                    streetAddress: '',
                    city: '',
                    state: '',
                    zipCode: ''
                }],
                accountCustomerNumber: '',
                affectedProductInInventory: null,
                productDetails: '',
                lotNumbers: '',
                quantity: '',
                additionalProductRows: [],
                affectedProductStatus: null,
                needReturnKit: 'no',
                confirmationReceived: false,
                todaysDate: ''
            },
            additionalFacilities: [],
            isSubmitting: false,
            validationErrors: {},
            filesUpload: [],
            thumbnailIndex: -1,
            // Product management data for step1-products component
            products: [],
            producFieldMetaList: [],
            // Tier field definitions (field_key/field_name/data_type/tier_level) for ProviderProductTierView, filtered to allowedFieldDataTypes
            fieldDefinitions: [],
            rawFieldDefinitions: [],
            fieldDefinitionsLoaded: false,
            isLoadingProductFields: false,
            communicationId: null,
            // Store original data for restoration when toggling affected product inventory
            originalRecallData: null,
            originalCommunicationId: null,
            infoData: {
                name: 'Recall Response',
                status: 'OPEN'
            },
            // Supplier Rep Email properties
            valueTag: [],
            enableValueTag: [],
            tag: '',
            emailError: '',
            ccvalue: [],
            autocompleteItems: [],
            originalValueTag: [],
            enumProductFieldDataType: ENUM_PRODUCT_FIELD_DATA_TYPE,
            enumDateTypeDefaultValue: ENUM_DATE_TYPE_DEFAULT_VALUE,
            // Allowed field data types for product fields
            // Note: the legacy flat product-field metadata (OrganizationProductFields / meta_data.product_fields)
            // names these "Product Number" and "Model", while the newer tier field definitions
            // (ProductFieldDefinitions, used by ProviderProductTierView) name the equivalent fields
            // "Product Number / GTIN" and "Model Number" - both variants are kept so each source matches.
            allowedFieldDataTypes: [
                'Item Number',
                'Lot Number',
                'Catalog Number',
                'Serial Number',
                'Product Number',
                'Product Number / GTIN',
                'Model',
                'Model Number',
                'NDC'
            ],
            recallResponseId: 0,
            isDrugRecall: false
        }
    },
    computed: {
        isFormValid() {
            const basicFieldsValid = (
                this.form.recallName.trim() !== '' &&
                this.form.recallDate !== '' &&
                // this.form.recallingFirmEmail.trim() !== '' &&
                this.form.contactInfo.yourName.trim() !== '' &&
                this.form.contactInfo.emailAddress.trim() !== '' &&
                this.form.facilityInfo.length > 0 &&
                this.form.facilityInfo[0].providerName.trim() !== '' &&
                this.form.confirmationReceived === true
            )
            return basicFieldsValid
        },
        infoDataCustom() {
            return {
                ...this.infoData,
                isCustomizedContent: true  // This will hide the "Add product" button too
            }
        },
        filteredItemsR() {
            return this.autocompleteItems.filter(i => {
                return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
            })
        },
        // todaysDateDisabledDates() {
        //     // Disable all dates before today
        //     const yesterday = new Date()
        //     yesterday.setDate(yesterday.getDate() - 1)
        //     return {
        //         to: yesterday
        //     }
        // }
    },
    created() {
        this.getEmailList()
        this.ensureFieldDefinitionsLoaded()
    },
    methods: {
        forceRerenderModel() {
            this.$refs.modal.show()
            this.bindResponseccEmails()
            this.showModal()
        },
        showModal() {
            //this.resetForm()
            if (this.responseFormData && this.responseFormData?.recallResponseId > 0) {
                this.populateFormFromResponseData(this.responseFormData)
            } else {
                // Then populate form data after reset if recallData is available
                if (this.recallData && Object.keys(this.recallData).length > 0) {
                    this.populateFormFromRecallData(this.recallData)
                }
                this.prefillUserInfo()
            }
            this.setTodaysDate()
        },
        bindResponseccEmails()
        {
            this.valueTag=[]
            this.enableValueTag=[]
            this.originalValueTag=[]
            this.options=[]
            this.ccvalue=[]
            var supplierCcEmails=this.CcEmails?.supplierRepCCEmails
            this.defaultEmailList = this.CcEmails?.supplierRepCCEmails
            var additionalRepEmails = this.CcEmails?.additionalCcEmails
            this.combineEmailList = supplierCcEmails?.concat(additionalRepEmails)
            this.combineEmailList?.forEach(x => {
                if (!this.options.includes(x)) {
                    this.options.push(x)
                }
                if (!this.ccvalue?.includes(x)) {
                    this.ccvalue.push(x)
                }
            })
            supplierCcEmails.forEach(x =>
            {
                if (this.valueTag.filter(s=>s.text==x).length<=0) {
                    this.valueTag.push({ 'text': x,'classes': ['ti-tag-disable-close']})
                    this.originalValueTag.push({ 'text': x,'classes': ['ti-tag-disable-close'] })
                    this.disableEmailTagList = true
                }
            })
            additionalRepEmails?.forEach(x =>
            {
                if (this.valueTag.filter(s=>s.text==x).length<=0) {
                    this.enableValueTag.push({'text': x})
                    this.valueTag.push({'text': x})
                }
            })
        },

        // Filter product field metadata to only include allowed data types
        filterAllowedProductFields(productFields) {
            if (!Array.isArray(productFields)) {
                return []
            }
            if(!this.isDrugRecall) {
                this.allowedFieldDataTypes = this.allowedFieldDataTypes.filter(field => field !== 'NDC')
            }
            return productFields.filter(field =>
                field &&
                field.name &&
                this.allowedFieldDataTypes.includes(field.name)
            )
        },

        // Remove non-allowed fields from existing products
        filterProductFields(products) {
            if (!Array.isArray(products)) {
                return []
            }
            return products.map(product => {
                if (!product.fields || !Array.isArray(product.fields)) {
                    return product
                }
                return {
                    ...product,
                    fields: product.fields.filter(field =>
                        field &&
                        field.field_name &&
                        this.allowedFieldDataTypes.includes(field.field_name)
                    )
                }
            })
        },

        // Load the tier field definitions (field_key/field_name/data_type/tier_level) once and cache them
        ensureFieldDefinitionsLoaded() {
            if (this.fieldDefinitionsLoaded) {
                return Promise.resolve(this.rawFieldDefinitions)
            }
            return communicationProductService.getFieldDefinitions().then(resp => {
                if (resp && !resp.error) {
                    const data = resp.data?.d ?? resp.data ?? []
                    this.rawFieldDefinitions = Array.isArray(data) ? data : []
                }
                return this.rawFieldDefinitions
            }).catch(() => {
                this.rawFieldDefinitions = []
                return this.rawFieldDefinitions
            }).finally(() => {
                this.fieldDefinitionsLoaded = true
                this.refreshFieldDefinitions()
            })
        },

        // Recompute the allowed tier field definitions (respects isDrugRecall via allowedFieldDataTypes) and
        // refresh the prop passed down to ProviderProductTierView
        refreshFieldDefinitions() {
            this.fieldDefinitions = (this.rawFieldDefinitions || []).filter(def =>
                this.allowedFieldDataTypes.includes(def.field_name)
            )
            return this.fieldDefinitions
        },

        buildDefinitionsByName(definitions) {
            const map = {}
            ;(definitions || []).forEach(def => {
                if (def && def.field_name) {
                    map[def.field_name.toLowerCase()] = def
                }
            })
            return map
        },

        // Extract the primitive display/edit value out of the old structured field value object
        extractPrimitiveFieldValue(fieldValue, dataType) {
            if (fieldValue == null) return null
            if (typeof fieldValue !== 'object') return fieldValue
            switch (dataType) {
            case ENUM_PRODUCT_FIELD_DATA_TYPE.DATE:
                return fieldValue.valueDate || null
            case ENUM_PRODUCT_FIELD_DATA_TYPE.NUMBER:
                return fieldValue.valueNumber != null ? String(fieldValue.valueNumber) : ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_SINGLE:
                return fieldValue.valueListSingle || ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_MULTIPLE:
                return Array.isArray(fieldValue.valueListMultiple) ? fieldValue.valueListMultiple.join(', ') : ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.YES_NO:
                return fieldValue.valueYesNo != null ? (fieldValue.valueYesNo ? 'Yes' : 'No') : ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TRUE_FALSE:
                return fieldValue.valueTrueFalse != null ? (fieldValue.valueTrueFalse ? 'True' : 'False') : ''
            default:
                return fieldValue.valueText || ''
            }
        },

        // Convert a legacy flat recall product ({description, fields: [{field_name, type, value}]}) into the
        // tier-nested shape ProviderProductTierView expects, keeping only allowedFieldDataTypes fields
        mapRecallProductToTierProduct(product, definitionsByName) {
            const t1 = {}, t2 = {}, t3 = {}, t4 = {}
            const byTier = { 1: t1, 2: t2, 3: t3, 4: t4 }
            ;(product?.fields || []).forEach(field => {
                if (!field || !field.field_name) return
                if (!this.allowedFieldDataTypes.includes(field.field_name)) return
                const def = definitionsByName[field.field_name.toLowerCase()]
                if (!def) return
                const value = this.extractPrimitiveFieldValue(field.value, field.type)
                if (value == null || value === '') return
                const bucket = byTier[def.tier_level] || t1
                bucket[def.field_key] = value
            })
            return {
                product_id: product?.id || null,
                name: product?.description || product?.name || '',
                quantity: product?.quantity ?? '',
                unitOfMeasure: product?.unitOfMeasure || '',
                tier_1_data: [{
                    values: t1,
                    tier_2_data: [{
                        values: t2,
                        tier_3_data: [{
                            values: t3,
                            tier_4_data: [{ values: t4 }]
                        }]
                    }]
                }]
            }
        },

        // Normalize a raw product list (either already tier-shaped or legacy flat) into tier-shaped products
        normalizeToTierProducts(rawProducts, definitionsByName) {
            if (!Array.isArray(rawProducts)) return []
            return rawProducts.map(product => {
                if (product && product.tier_1_data) {
                    return normalizeProductsFromApi([product])[0]
                }
                return this.mapRecallProductToTierProduct(product, definitionsByName)
            })
        },

        filterTierProductValues(values, allowedFieldKeys) {
            if (!values) return {}
            const filtered = {}
            Object.keys(values).forEach(key => {
                if (allowedFieldKeys.has(key)) filtered[key] = values[key]
            })
            return filtered
        },

        // Strip any values whose field_key is not in allowedFieldKeys from every tier level
        filterTierProducts(products, allowedFieldKeys) {
            if (!Array.isArray(products)) return []
            const filterT4 = t4 => ({ values: this.filterTierProductValues(t4?.values, allowedFieldKeys) })
            const filterT3 = t3 => ({
                values: this.filterTierProductValues(t3?.values, allowedFieldKeys),
                tier_4_data: (t3?.tier_4_data || []).map(filterT4)
            })
            const filterT2 = t2 => ({
                values: this.filterTierProductValues(t2?.values, allowedFieldKeys),
                tier_3_data: (t2?.tier_3_data || []).map(filterT3)
            })
            const filterT1 = t1 => ({
                values: this.filterTierProductValues(t1?.values, allowedFieldKeys),
                tier_2_data: (t1?.tier_2_data || []).map(filterT2)
            })
            return products.map(product => ({
                ...product,
                tier_1_data: (product.tier_1_data || []).map(filterT1)
            }))
        },

        hideModal() {
            this.validationErrors = {}
            if (this.$refs.observer) {
                this.$refs.observer.reset()
            }
            this.$refs.modal.hide()
        },

        resetForm() {
            this.form = {
                recallName: '',
                recallDate: '',
                recallingFirmEmail: '',
                contactInfo: {
                    yourName: '',
                    yourTitle: '',
                    emailAddress: '',
                    telephoneNumber: ''
                },
                facilityInfo: [{
                    providerName: '',
                    streetAddress: '',
                    city: '',
                    state: '',
                    zipCode: ''
                }],
                accountCustomerNumber: '',
                affectedProductInInventory: null,
                productDetails: '',
                lotNumbers: '',
                quantity: '',
                additionalProductRows: [],
                affectedProductStatus: null,
                needReturnKit: 'no',
                confirmationReceived: false,
                todaysDate: ''
            }
            this.additionalFacilities = []
            this.validationErrors = {}
            this.isSubmitting = false
            this.filesUpload = []
            this.products = []
            this.originalRecallData = null
            this.originalCommunicationId = null
            this.setTodaysDate()
        },

        populateFormFromRecallData(recallData) {
            // Store original recall data for potential restoration
            this.originalRecallData = { ...recallData }

            // Populate recall name
            if (recallData.communicationName) {
                this.form.recallName = recallData.communicationName
            }
            // Populate recall date
            if (recallData.communicationDate) {
                this.form.recallDate = recallData.communicationDate
            }
            // Populate recalling firm email with supplier email
            if (recallData.supplier_email) {
                this.form.recallingFirmEmail = recallData.supplier_email
            } else if (recallData.recalling_firm) {
                // Fallback: Extract email from recalling firm if it contains email
                const emailMatch = recallData.recalling_firm.match(/[\w.-]+@[\w.-]+\.\w+/)
                if (emailMatch) {
                    this.form.recallingFirmEmail = emailMatch[0]
                }
            } else if (recallData.supplier_name && recallData.supplier_name.includes('@')) {
                // Check if supplier name contains email
                this.form.recallingFirmEmail = recallData.supplier_name
            }
            // Set communicationId for fetching product data
            if (recallData.id || recallData.communicationId) {
                this.communicationId = recallData.id || recallData.communicationId
                this.originalCommunicationId = this.communicationId // Store original
                // Fetch product data using the same API as step1_products
                this.fetchCommunicationDetail(this.communicationId)
            }
            if (this.products.length > 0) {
                this.form.affectedProductInInventory = 'yes'
            } else {
                this.form.affectedProductInInventory = 'no'
            }
        },

        populateFormFromResponseData(responseData) {
            if (responseData.id || responseData.communicationId) {
                this.communicationId = responseData.id || responseData.communicationId
                this.originalCommunicationId = this.communicationId // Store original
                // Fetch product data using the same API as step1_products
                this.fetchCommunicationDetail(this.communicationId, true)
            }
            // Store original response data for potential restoration
            this.originalRecallData = { ...responseData }
            this.recallResponseId = responseData.recallResponseId || 0
            // Populate recall information
            if (responseData.recallName || responseData.communicationName) {
                this.form.recallName = responseData.recallName || responseData.communicationName
            }
            if (responseData.recallDate || responseData.communicationDate) {
                this.form.recallDate = responseData.recallDate || responseData.communicationDate
            }
            if (responseData.recallingFirmEmail || responseData.supplier_email) {
                this.form.recallingFirmEmail = responseData.recallingFirmEmail || responseData.supplier_email
            }
            // Populate contact information
            this.form.contactInfo = {
                yourName: responseData.contactName || '',
                yourTitle: responseData.contactTitle || '',
                emailAddress: responseData.contactEmail || '',
                telephoneNumber: responseData.contactPhone || ''
            }
            // Populate facility information
            if (responseData.facilities && Array.isArray(responseData.facilities) && responseData.facilities.length > 0) {
                this.form.facilityInfo = responseData.facilities.map(facility => ({
                    providerName: facility.providerName || '',
                    streetAddress: facility.streetAddress || '',
                    city: facility.city || '',
                    state: facility.state || '',
                    zipCode: facility.zipCode || ''
                }))
            }

            // Populate other form fields
            if (responseData.accountCustomerNumber) {
                this.form.accountCustomerNumber = responseData.accountCustomerNumber
            }
            if (responseData.affectedProductInInventory) {
                this.form.affectedProductInInventory = responseData.affectedProductInInventory
            }
            if (responseData.affectedProductStatus) {
                this.form.affectedProductStatus = responseData.affectedProductStatus
            }
            if (responseData.needReturnKit) {
                this.form.needReturnKit = responseData.needReturnKit
            }
            if (responseData.confirmationReceived !== undefined) {
                this.form.confirmationReceived = responseData.confirmationReceived
            }

            // Populate product details
            if (responseData.productDetails) {
                this.form.productDetails = responseData.productDetails
            }
            if (responseData.lotNumbers) {
                this.form.lotNumbers = responseData.lotNumbers
            }
            if (responseData.quantity) {
                this.form.quantity = responseData.quantity
            }
            if (responseData.products && Array.isArray(responseData.products) && responseData.products.length > 0) {
                this.form.affectedProductInInventory = 'yes'
                // Saved response products are already tier-shaped; normalize + strip any non-allowed fields
                this.ensureFieldDefinitionsLoaded().then(() => {
                    const allowedDefinitions = this.refreshFieldDefinitions()
                    const allowedFieldKeys = new Set(allowedDefinitions.map(def => def.field_key))
                    const definitionsByName = this.buildDefinitionsByName(allowedDefinitions)
                    const normalized = this.normalizeToTierProducts(responseData.products, definitionsByName)
                    this.products = this.filterTierProducts(normalized, allowedFieldKeys)
                })
            } else if (this.communicationId) {
                this.fetchProductsByCommunicationId(this.communicationId)
            } else if (this.form.affectedProductInInventory !== 'no') {
                this.form.affectedProductInInventory = 'no'
                this.products = []
            }

            // Set communicationId for future operations
            if (responseData.id || responseData.communicationId) {
                this.communicationId = responseData.id || responseData.communicationId
                this.originalCommunicationId = this.communicationId
            }
        },

        fetchCommunicationDetail(communicationId, isResponseFormSubmitted=false, skipAffectedProductInventoryUpdate=false) {
            if (!communicationId) return Promise.resolve()
            this.isLoadingProductFields = true
            return Promise.all([
                supplierRecallService.communicationDetail(communicationId),
                this.ensureFieldDefinitionsLoaded()
            ]).then(([res]) => {
                if (!res.error) {
                    this.isDrugRecall = res.data.d.products.length > 0 && res.data.d.products[0].fields.some(field => field.field_name === 'NDC')
                    // Extract product field metadata from the communication detail response
                    if (res.data.d.meta_data && res.data.d.meta_data.product_fields) {
                        // Filter to only allowed field data types
                        const allProductFields = res.data.d.meta_data.product_fields
                        this.producFieldMetaList = this.filterAllowedProductFields(allProductFields)
                    }
                    // Refresh tier field definitions now that isDrugRecall/allowedFieldDataTypes are settled
                    this.refreshFieldDefinitions()

                    if (!isResponseFormSubmitted) {
                        const definitionsByName = this.buildDefinitionsByName(this.fieldDefinitions)
                        const _productData = res.data.d.products || []
                        this.products = _productData.map(product => this.mapRecallProductToTierProduct(product, definitionsByName))

                        // Set affected product in inventory based on products (only if not skipped)
                        if (!skipAffectedProductInventoryUpdate) {
                            if (this.products.length > 0) {
                                this.form.affectedProductInInventory = 'yes'
                            } else {
                                this.form.affectedProductInInventory = 'no'
                            }
                        }
                    }
                }
            }).catch(error => {
                console.error('Error fetching communication detail:', error)
                // Fallback: no products found
                this.form.affectedProductInInventory = 'no'
                this.products = []
            }).finally(() => {
                this.isLoadingProductFields = false
            })
        },

        fetchProductsByCommunicationId(communicationId) {
            if (!communicationId) return Promise.resolve()
            this.isLoadingProductFields = true
            return communicationProductService.getProducts(communicationId)
                .then(resp => {
                    const data = resp.data?.d ?? resp.data ?? []
                    if (Array.isArray(data) && data.length > 0) {
                        this.form.affectedProductInInventory = 'yes'
                        return this.ensureFieldDefinitionsLoaded().then(() => {
                            const allowedDefinitions = this.refreshFieldDefinitions()
                            const allowedFieldKeys = new Set(allowedDefinitions.map(def => def.field_key))
                            const definitionsByName = this.buildDefinitionsByName(allowedDefinitions)
                            const normalized = this.normalizeToTierProducts(data, definitionsByName)
                            this.products = this.filterTierProducts(normalized, allowedFieldKeys)
                        })
                    }
                    this.form.affectedProductInInventory = 'no'
                    this.products = []
                })
                .catch(error => {
                    console.error('Error fetching recall products for communicationId', communicationId, error)
                    this.form.affectedProductInInventory = 'no'
                    this.products = []
                })
                .finally(() => {
                    this.isLoadingProductFields = false
                })
        },

        prefillUserInfo() {
            const userInfo = this.$store.state.user
            if (userInfo) {
                if (userInfo.full_name) {
                    this.form.contactInfo.yourName = `${userInfo.full_name}`
                }
                if (userInfo.email) {
                    this.form.contactInfo.emailAddress = userInfo.email
                }
                if (userInfo.phone) {
                    this.form.contactInfo.telephoneNumber = userInfo.phone
                }
                if (userInfo.title) {
                    this.form.contactInfo.yourTitle = userInfo.title
                }
            }
            const facilityInfo = this.$store.state.organization
            if (facilityInfo && this.form.facilityInfo.length > 0) {
                if (facilityInfo.name || facilityInfo.organizationName) {
                    this.form.facilityInfo[0].providerName = facilityInfo.name || facilityInfo.organizationName
                }
                if (facilityInfo.add1) {
                    this.form.facilityInfo[0].streetAddress = facilityInfo.add1
                }
                if (facilityInfo.city) {
                    this.form.facilityInfo[0].city = facilityInfo.city
                }
                if (facilityInfo.state) {
                    this.form.facilityInfo[0].state = facilityInfo.state
                }
                if (facilityInfo.zipCode || facilityInfo.zip) {
                    this.form.facilityInfo[0].zipCode = facilityInfo.zipCode || facilityInfo.zip
                }
            }
        },

        onAffectedProductChange(value) {
            this.form.affectedProductInInventory = value
            // Clear or initialize product details based on selection
            if (value === 'no') {
                this.products = []
                if (this.$refs.tierProducts && typeof this.$refs.tierProducts.resetEditingStates === 'function') {
                    this.$refs.tierProducts.resetEditingStates()
                }
            } else if (value === 'yes') {
                this.isLoadingProductFields = false
                // Re-populate original recall product data
                this.repopulateOriginalProductData()
            }
        },

        repopulateOriginalProductData() {
            // If we have a stored original communicationId, re-fetch the communication details
            if (this.originalCommunicationId) {
                this.communicationId = this.originalCommunicationId // Restore original communicationId
                this.fetchCommunicationDetail(this.originalCommunicationId, false, true)
            }
            // If we have stored original recall data with products, re-populate from that
            else if (this.originalRecallData && this.originalRecallData.products && Array.isArray(this.originalRecallData.products) && this.originalRecallData.products.length > 0) {
                this.ensureFieldDefinitionsLoaded().then(() => {
                    const allowedDefinitions = this.refreshFieldDefinitions()
                    const allowedFieldKeys = new Set(allowedDefinitions.map(def => def.field_key))
                    const definitionsByName = this.buildDefinitionsByName(allowedDefinitions)
                    const normalized = this.normalizeToTierProducts(this.originalRecallData.products, definitionsByName)
                    this.products = this.filterTierProducts(normalized, allowedFieldKeys)
                })
            }
            // Always ensure at least one product for user to add product information
            else {
                console.log('No original data found, creating default product for user input')
                this.initializeDefaultProduct()
            }
        },

        initializeDefaultProduct() {
            // Create a single blank tier product for the user to fill in via ProviderProductTierView
            this.products = [{ name: '', quantity: '', unitOfMeasure: '', tier_1_data: [] }]
        },

        getDefaultValueForType(type) {
            switch (type) {
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TEXT:
                return { valueText: '' }
            case ENUM_PRODUCT_FIELD_DATA_TYPE.NUMBER:
                return { valueNumber: '' }
            case ENUM_PRODUCT_FIELD_DATA_TYPE.DATE:
                return { valueDate: null }
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_SINGLE:
                return { valueListSingle: null }
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_MULTIPLE:
                return { valueListMultiple: [] }
            case ENUM_PRODUCT_FIELD_DATA_TYPE.YES_NO:
                return { valueYesNo: null }
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TRUE_FALSE:
                return { valueTrueFalse: null }
            default:
                return { valueText: '' }
            }
        },

        validateFieldValue(field) {
            // Check if field has a valid value based on its type
            if (!field.value) {
                return false
            }
            const fieldMeta = this.producFieldMetaList.find(f => f.name === field.field_name)
            const fieldType = fieldMeta ? fieldMeta.type : ENUM_PRODUCT_FIELD_DATA_TYPE.TEXT

            switch (fieldType) {
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TEXT:
                return field.value.valueText && field.value.valueText.trim() !== ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.NUMBER:
                return field.value.valueNumber && field.value.valueNumber !== ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.DATE:
                return field.value.valueDate !== null && field.value.valueDate !== ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_SINGLE:
                return field.value.valueListSingle !== null && field.value.valueListSingle !== ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_MULTIPLE:
                return field.value.valueListMultiple && Array.isArray(field.value.valueListMultiple) && field.value.valueListMultiple.length > 0
            case ENUM_PRODUCT_FIELD_DATA_TYPE.YES_NO:
                return field.value.valueYesNo !== null
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TRUE_FALSE:
                return field.value.valueTrueFalse !== null
            default:
                return field.value.valueText && field.value.valueText.trim() !== ''
            }
        },
        onProductsChanged() {
            // ProviderProductTierView emits `change` after updating `products` via v-model, so this.products
            // already reflects the latest list by the time this handler runs
            if (this.products && this.products.length > 0) {
                this.form.affectedProductInInventory = 'yes'
            } else {
                this.form.affectedProductInInventory = 'no'
            }
        },

        handleFieldTypeChange(productIndex, fieldIndex, newFieldName) {
            if (this.products[productIndex] && this.products[productIndex].fields[fieldIndex]) {
                const field = this.products[productIndex].fields[fieldIndex]
                field.field_name = newFieldName
                // Update the field type based on metadata
                const fieldMeta = this.producFieldMetaList.find(f => f.name === newFieldName)
                if (fieldMeta) {
                    field.type = fieldMeta.type
                    field.required = fieldMeta.required || false
                    // Reset value to appropriate type
                    field.value = this.getDefaultValueForType(fieldMeta.type)
                }
            }
        },

        getProductsData() {
            // Get products data from ProviderProductTierView
            if (this.$refs.tierProducts) {
                return this.$refs.tierProducts.getProducts()
            }
            return []
        },

        getFieldType(fieldName) {
            // Get field type from metadata
            const fieldMeta = this.producFieldMetaList.find(f => f.name === fieldName)
            return fieldMeta ? fieldMeta.type : ENUM_PRODUCT_FIELD_DATA_TYPE.TEXT
        },

        formatFieldValue(field) {
            if (!field.value) {
                return ''
            }

            const fieldType = this.getFieldType(field.field_name)
            switch (fieldType) {
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TEXT:
                return field.value.valueText || ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.NUMBER:
                return field.value.valueNumber || ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.DATE:
                return field.value.valueDate || ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_SINGLE:
                return field.value.valueListSingle || ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.LIST_MULTIPLE:
                return field.value.valueListMultiple ? field.value.valueListMultiple.join(', ') : ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.YES_NO:
                return field.value.valueYesNo !== null ? (field.value.valueYesNo ? 'Yes' : 'No') : ''
            case ENUM_PRODUCT_FIELD_DATA_TYPE.TRUE_FALSE:
                return field.value.valueTrueFalse !== null ? (field.value.valueTrueFalse ? 'True' : 'False') : ''
            default:
                return field.value.valueText || ''
            }
        },

        addProductRow() {
            this.form.additionalProductRows.push({
                productDetails: '',
                lotNumbers: '',
                quantity: ''
            })
        },

        removeProductRow(index) {
            this.form.additionalProductRows.splice(index, 1)
        },
        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return emailRegex.test(email)
        },
        addFacility() {
            this.form.facilityInfo.push({
                providerName: '',
                streetAddress: '',
                city: '',
                state: '',
                zipCode: ''
            })
        },

        removeFacility(index) {
            if (this.form.facilityInfo.length > 1) {
                this.form.facilityInfo.splice(index, 1)
            }
        },

        validateForm() {
            const errors = {}
            if (!this.form.recallName.trim()) {
                errors.recallName = 'Recall name is required'
            }

            if (!this.form.recallDate) {
                errors.recallDate = 'Recall date is required'
            }
            if (!this.form.contactInfo.yourName.trim()) {
                errors.yourName = 'Your name is required'
            }
            // Email validation - check if emails are valid when provided
            if (this.form.recallingFirmEmail && this.form.recallingFirmEmail.trim() !== '') {
                if (!this.isValidEmail(this.form.recallingFirmEmail.trim())) {
                    errors.recallingFirmEmail = 'Please enter a valid recalling firm email address'
                }
            }

            if (this.form.contactInfo.emailAddress && this.form.contactInfo.emailAddress.trim() !== '') {
                if (!this.isValidEmail(this.form.contactInfo.emailAddress.trim())) {
                    errors.contactEmailAddress = 'Please enter a valid contact email address'
                }
            }

            // Supplier Rep Email validation
            if (this.ccvalue && this.ccvalue.length > 0) {
                for (let i = 0; i < this.ccvalue.length; i++) {
                    const supplierEmail = this.ccvalue[i].trim()
                    if (supplierEmail && !this.isValidEmail(supplierEmail)) {
                        errors[`supplierRepEmail_${i}`] = `Supplier Rep Email #${i + 1}: Please enter a valid email address`
                    }
                }
            }

            if (!this.form.facilityInfo.length > 0 || !this.form.facilityInfo[0]?.providerName.trim()) {
                errors.providerName = 'At least one provider name is required for the facility'
            }
            if (!this.form.facilityInfo.length > 0 || !this.form.facilityInfo[0]?.streetAddress.trim()) {
                errors.streetAddress = 'At least one address line 1 is required for the facility'
            }
            if (this.form.affectedProductInInventory === null) {
                errors.affectedProductInInventory = 'Please indicate if you had affected product in inventory'
            }
            // Product validation for affected product in inventory
            if (this.form.affectedProductInInventory === 'yes') {
                // Get current product data from ProviderProductTierView component
                const currentProducts = this.getProductsData()

                // Validate that at least one product exists when "yes" is selected
                if (!currentProducts || currentProducts.length === 0) {
                    errors.products = 'Please add at least one product when affected product is in inventory'
                } else {
                    for (let i = 0; i < currentProducts.length; i++) {
                        const product = currentProducts[i]
                        const productPrefix = `Product #${i + 1}`
                        if (!product.name || !String(product.name).trim()) {
                            errors[`product_${i}_description`] = `${productPrefix}: Product name is required`
                        }
                    }
                }
            }
            if (!this.form.affectedProductStatus || this.form.affectedProductStatus.trim() === '') {
                errors.affectedProductStatus = 'Please confirm how the affected product was handled'
            }
            if (!this.form.needReturnKit || this.form.needReturnKit.trim() === '') {
                errors.needReturnKit = 'Please indicate if you need a return kit'
            }
            if (!this.form.confirmationReceived) {
                errors.confirmationReceived = 'Please confirm that you have received and understood this notice'
            }
            this.validationErrors = errors
            return Object.keys(errors).length === 0
        },
        removevalidation() {
            var ele = this.$refs.response_ccemails.$el.getElementsByClassName('ti-input')
            ele[0].style = ' '
        },
        addemailcolor() {
            var ele = this.$refs.response_ccemails.$el.getElementsByClassName('ti-input')
            ele[0].style = 'border-color:#5ec3ff !important'
        },
        async submitForm() {
            // Validate VeeValidate form fields in RecallResponseModal
            const isRecallFormValid = await this.$refs.observer.validate()

            // Validate ProviderProductTierView component if it exists and has products
            let isProductManagerValid = true
            if (this.$refs.tierProducts && this.form.affectedProductInInventory === 'yes') {
                isProductManagerValid = await this.$refs.tierProducts.validate()
            }

            // Validate custom form logic
            const customValidationPassed = this.validateForm()

            // If any validation fails, show error and return
            if (!isRecallFormValid || !isProductManagerValid || !customValidationPassed) {
                // Check if there are product-related validation errors
                const hasProductErrors = Object.keys(this.validationErrors).some(key =>
                    key.startsWith('product') || key === 'products'
                )

                // If there are product errors or ProductManager validation failed, open accordion automatically
                if ((hasProductErrors || !isProductManagerValid) && this.form.affectedProductInInventory === 'yes') {
                    // Wait for next tick to ensure DOM is updated
                    this.$nextTick(() => {
                        // Check if the accordion is currently collapsed
                        const collapseElement = document.getElementById('product-manager-collapse')
                        if (collapseElement && !collapseElement.classList.contains('show')) {
                            // Accordion is closed, so toggle it to open
                            this.$root.$emit('bv::toggle::collapse', 'product-manager-collapse')
                        }

                        // Scroll to product section after a short delay to allow accordion to open
                        setTimeout(() => {
                            const productSection = document.querySelector('.product-manager-accordion-wrapper')
                            if (productSection) {
                                productSection.scrollIntoView({ behavior: 'smooth', block: 'center' })
                            }
                        }, 350) // Wait for accordion animation to complete
                    })
                }

                // Show the first specific validation error instead of generic message
                if (!customValidationPassed && Object.keys(this.validationErrors).length > 0) {
                    const firstErrorKey = Object.keys(this.validationErrors)[0]
                    const firstErrorMessage = this.validationErrors[firstErrorKey]
                    this._showToast('Please fill in all required fields correctly', { variant: 'danger' })
                } else if (!isProductManagerValid || !isRecallFormValid) {
                    this._showToast('Please fill in all required fields correctly', { variant: 'danger' })
                }
                return
            }

            // Check if recalling firm email is missing
            if (!this.form.recallingFirmEmail || this.form.recallingFirmEmail.trim() === '') {
                this.showEmailConfirmationModal()
                return
            }
            else{
                this.proceedWithSubmission(true)
            }
        },

        showEmailConfirmationModal() {
            this.$refs.emailConfirmModal.show()
        },

        markCompleteWithoutEmail() {
            this.$refs.emailConfirmModal.hide()
            this.hideModal()
            this.proceedWithSubmission(false)
            // Emit event to parent to mark recall as complete without sending email
            this.$emit('mark-recall-complete', {
                sendEmail: false,
                hasRecallingFirmEmail: false
            })
        },

        cancelEmailConfirm() {
            this.$refs.emailConfirmModal.hide()
        },

        async proceedWithSubmission(sendEmail = true) {
            this.isSubmitting = true
            try {
                const formData = this.prepareSubmissionData()

                // Add email settings to FormData
                formData.append('sendEmail', sendEmail)
                formData.append('hasRecallingFirmEmail', !!this.form.recallingFirmEmail)
                // Call API service to submit recall response
                const response = await providerRecallService.submitRecallResponse(formData,this.recallResponseId,this.communicationId, this.providerCommunicationId)
                if (response.error) {
                    this._showToast('Failed to submit recall response. Please try again.', { variant: 'danger' })
                }
                else{
                    // this._showToast('Recall response submitted successfully', { variant: 'success' })
                    if (sendEmail) {
                        this.$emit('response-submitted', JSON.parse(formData.get('data')))
                    }
                    // // Emit event to refresh parent data after successful submission
                    this.$emit('refresh-recall-data')
                }
                // Hide current modal first
                this.hideModal()
                // Emit response submitted event only if email is being sent
            } catch (error) {
                console.error('Error submitting recall response:', error)
                this._showToast('Failed to submit recall response. Please try again.', { variant: 'danger' })
            } finally {
                this.isSubmitting = false
            }
        },

        openResponseModal(formData, emailSent) {
            // Emit event to parent to open ResponseModal
            this.$emit('open-response-modal', {
                type: 'recall-response',
                data: formData,
                emailSent: emailSent
            })
        },

        prepareSubmissionData() {
            // Create FormData object
            let formData = new FormData()

            // Get advanced product data from custom product management
            let productInfo = {
                details: this.form.productDetails,
                lotNumbers: this.form.lotNumbers,
                quantity: this.form.quantity,
                additionalRows: this.form.additionalProductRows,
            }

            // If using advanced product management, get product data
            if (this.form.affectedProductInInventory === 'yes') {
                const advancedProductData = this.getProductsData()
                // Use the fresh tier-shaped product data from ProviderProductTierView component
                if (advancedProductData && advancedProductData.length > 0) {
                    productInfo = {
                        ...productInfo,
                        products: toUpsertPayload(advancedProductData).products,
                        totalProducts: advancedProductData.length
                    }
                }
            }
            formData.append('contactInfo', JSON.stringify(this.form.contactInfo))
            formData.append('accountCustomerNumber', this.form.accountCustomerNumber)
            formData.append('needReturnKit', this.form.needReturnKit ? this.form.needReturnKit : 'No')
            formData.append('confirmationReceived', this.form.confirmationReceived ? this.form.confirmationReceived : 'No')
            formData.append('affectedProductStatus', this.form.affectedProductStatus ? this.form.affectedProductStatus : 'No')
            formData.append('todaysDate', this.form.todaysDate ? this.form.todaysDate : 'No')
            formData.append('recallInfo', JSON.stringify({
                name: this.form.recallName,
                date: this.form.recallDate,
                recallingFirmEmail: this.form.recallingFirmEmail
            }))
            formData.append('recallName', this.form.recallName)
            formData.append('recallDate', this.form.recallDate)
            formData.append('recallingFirmEmail', this.form.recallingFirmEmail)
            formData.append('contactName', this.form.contactInfo?.yourName)
            formData.append('contactEmail', this.form.contactInfo?.emailAddress)
            formData.append('contactPhone', this.form.contactInfo?.telephoneNumber)
            formData.append('contactTitle', this.form.contactInfo?.yourTitle)
            formData.append('facilityInfo', JSON.stringify(this.form.facilityInfo))
            formData.append('affectedProductInInventory', this.form.affectedProductInInventory ? this.form.affectedProductInInventory : 'No')
            formData.append('productInfo', JSON.stringify(productInfo))
            formData.append('communicationType', this.communicationType)
            // Handle file uploads
            this.filesUpload.forEach((x, i) => {
                if (!x.id) {
                    formData.append('document', x.file)
                }
                formData.append('documentInfo[' + i + '].id', x.id ? x.id : 0)
            })
            if (this.ccvalue.length > 0) {
                for (let k = 0; k < this.ccvalue.length; k++) {
                    formData.append('additionalCcEmails', this.ccvalue[k])
                    formData.append('supplierRepCCEmails', this.ccvalue[k])
                }
            }
            return formData
        },

        setTodaysDate() {
            const today = new Date()
            const month = String(today.getMonth() + 1).padStart(2, '0')
            const day = String(today.getDate()).padStart(2, '0')
            const year = today.getFullYear()
            const formattedDate = `${month}/${day}/${year}`
            this.form.todaysDate = formattedDate
        },

        handleFilesUpload() {
            let uploadedFiles = this.$refs.files.files
            for ( let i = 0; i < uploadedFiles.length; i++ ) {
                if(uploadedFiles[i].size == 0){
                    this._showToast('Documented failed to upload. Please try again.', { variant: 'danger' })
                }
                else
                {
                    this.filesUpload.push({
                        file: uploadedFiles[i],
                        note: '',
                        is_thumbnail: false,
                        isAddedBeforeSave: true
                    })
                }
            }
            this.$refs.files.value = ''
        },

        removeDocument(index) {
            this.filesUpload.splice(index, 1)
            this.thumbnailIndex = this.filesUpload.findIndex(x => x.is_thumbnail === true)
        },

        changeRecallStatus() {
            this.$emit('onSubmit','yes')
            this.hideModal()
        },

        addCheck(val) {
            let isDuplicateEmail = false
            let tagArray = []
            let emailArray = []
            this.valueTag = []
            let duplicateEmail = []

            this.originalValueTag.forEach(x => {
                if(emailArray.includes(x.text)) {
                    duplicateEmail.push(x.text)
                    isDuplicateEmail = true
                }
                emailArray.push(x.text)
                tagArray.push(x)
            })

            val.forEach(x => {
                if(x.tiClasses.includes('ti-duplicate')) {
                    duplicateEmail.push(x.text)
                    isDuplicateEmail = true
                }
                if (this.originalValueTag.find(y=>y.text==x.text) == null && !x.tiClasses.includes('ti-duplicate')) {
                    tagArray.push(x)
                }
            })

            val = []
            this.valueTag = tagArray
            val = tagArray

            if(isDuplicateEmail) {
                duplicateEmail.forEach(x => {
                    val.push(x)
                })
                this.setvalidation()
                this.emailError = 'The email has been already used.'
            } else {
                if (val.length > 0) {
                    this.ccvalue = []
                    val.forEach(x => {
                        this.checkEmailValidation(x.text)
                        if (!this.emailError) {
                            this.ccvalue.push(x.text)
                        }
                    })
                    if (this.ccvalue.length > 1) {
                        var valueOriginal = this.ccvalue.length
                        var valcurrent = val.length - 1
                        var b = this.isValidEmail(val[valcurrent].text.trim())
                        if (b) {
                            var i = 0
                            for (i = 0; i < valueOriginal - 1; i++) {
                                if (this.ccvalue[i].trim() === val[valcurrent].text.trim()) {
                                    this.setvalidation()
                                    this.emailError = 'The email has been already used.'
                                }
                            }
                        }
                    }
                    this.removevalidation()
                } else {
                    this.ccvalue = []
                    this.removevalidation()
                }
            }
        },

        checkEmailValidation(email) {
            if (!email) {
                this.setvalidation()
                this.emailError = 'Email is required'
            } else { this.emailError = '' }
            if (email) {
                // Removed const re line - now using isValidEmail method
                var b = this.isValidEmail(email.trim())
                this.removevalidation()
                if (!b) {
                    this._showToast('Please enter valid email address', { variant: 'warning' , title: 'Notice'})
                    this.setvalidation()
                }
            }
        },

        setvalidation() {
            this.addemailcolor()
        },


        _showToast(message, options = {}) {
            // Hide any existing toasts before showing new one
            this.$bvToast.hide()
            this.$bvToast.toast(message, {
                title: options.title || 'Notification',
                variant: options.variant || 'info',
                toaster: 'b-toaster-top-center',
                solid: true,
                appendToast: false,
                autoHideDelay: 5000,
                ...options
            })
        },

        getEmailList() {
            providerRecallService
                .GetEmailList(this.$store.state.orgId)
                .then((resp) => {
                    if (!resp.error) {
                        resp.data.d.forEach((val) => {
                            this.autocompleteItems.push({
                                text: val.email
                            })
                        })
                    }
                })
        }
    }
}